// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
import Axios from 'axios';


// Main service class to read timeline data from portal-api.
@injectable()
export default class QRCodeService {
  // protected urlPrefix = 'dashboard';  // path to portal-api endpoint.
  protected urlPrefix = 'qrcodes';
  static diToken = Symbol('qrcode-service');

  static testTimelines = false; // WXYZ
  static testNewForm = false; // WXYZ
  static testAssetsCollections = false;
  


  // Get a list of job request lines from the portal-api.
  // To follow the existing data structure, we insert the orderId at 'ListRequestParams.searchKeyword' (kind of kludgy).
  async getQRCodes(): Promise<Array<string> | undefined> {
    try {        

      const url = this.urlPrefix;
      let data;
      if (QRCodeService.testTimelines == false)
      {
        data  = await Axios.post(url);
      }
      else
      {
        data = [ "111111", "222222", "333333", "444444"];
      }

      // Return reponse to caller.
      return data;
    } 
    catch (err) {
      console.log("****** Exception in getQRCode:", err);
      throw err;  // TBD: may want to handle this here.
    }

    return undefined;
  }

  // Send request to update a timeline to portal-api.
  // Returns a timelinedata obj which will be used to update the chart.
  async updateQRCode(qrCode: string, qrStatus: string): Promise<string | undefined> {

    const url = `${this.urlPrefix}/status?qrCode=${qrCode}&status=${qrStatus}`;
    // if there are ids, merge them with the block data.
    console.log("**** in updateQRStatus:", url);

    try {      
      if (QRCodeService.testTimelines == false) {
        const { data } = await Axios.put(url);

        if(data === undefined) {
          return undefined;
        }

        return new data;
      }
    }
    catch (err) {
      console.log("****** Exception in updateQRStatus:", err);
      throw err;  // TBD: may want to handle this instead of rethrow.
    }

    return undefined;
  }

  // Send request to add a new timeline to portal-api.
  // Returns a timelinedata obj which will be used to update the chart.
  async addQRCode(qrCode: string): Promise<string | undefined> {

    const url = `${this.urlPrefix}/qrcodes/add?qrCode=${qrCode}`;

    try {
      
      if (QRCodeService.testTimelines == false) {
        const { data } = await Axios.post(url);

        if(data === undefined) {
          return undefined;
        }

        return data;
      }
    }
    catch (err) {
      console.log("****** Exception in addQRCode:", err);
      throw err;  // TBD: may want to handle this instead of rethrow.
    }
    return undefined;
  }

  // Send request to add a new timeline to portal-api.
  // Returns a timelinedata obj which will be used to update the chart.
  async deleteQRCode(qrCode: string): Promise<string | undefined> {

    const url = `${this.urlPrefix}/qrcodes/delete?qrCode=${qrCode}`;

    try {
      
      if (QRCodeService.testTimelines == false) {
        const { data } = await Axios.post(url);

        if(data === undefined) {
          return undefined;
        }

        return data;
      }
    }
    catch (err) {
      console.log("****** Exception in deleteQRCode:", err);
      throw err;  // TBD: may want to handle this instead of rethrow.
    }
    return undefined;
  }
}
